import {
  AdyenPaymentLinkResponse,
  PaginatedParams,
  PaginatedResponse,
  type Profile,
  StampCard,
  StampCardPopulated,
} from '@supsupclub/types';

import { supxios } from './supxios';

export const FETCH_PROFILE_QUERY = 'FETCH_PROFILE';
export const fetchProfile = async (id: string) => {
  const resp = await supxios.get<Profile>(`/profiles/${id}`);

  return resp.data;
};

export const updateProfile = async (id: string, profile: Partial<Profile>) => {
  const resp = await supxios.put<Profile>(`/profiles/${id}`, profile);

  return resp.data;
};

export const getStampCardAdyenPaymentLink = async () => {
  const resp = await supxios.post<AdyenPaymentLinkResponse>(
    '/stamp-cards/payment-link',
  );
  return resp.data;
};

export const getStampCards = async (userId: string) => {
  const resp = await supxios.get<StampCard[]>(`/stamp-cards/user/${userId}`);
  return resp.data;
};

export const getAvailableStampCards = async () => {
  const resp = await supxios.get<StampCard[]>('/stamp-cards/available');
  return resp.data;
};

export const FETCH_ADMIN_STAMP_CARDS_QUERY = 'FETCH_ADMIN_STAMP_CARDS';
export const getAllAdminStampCards = async (params?: PaginatedParams) => {
  const mergeParams = {
    limit: 10,
    page: 1,
    ...params,
  };
  return (
    await supxios.get<PaginatedResponse<StampCardPopulated>>(
      '/admin/stamp-cards',
      { params: mergeParams },
    )
  ).data;
};
